import {
  ensureUsercentricsV3Loaded,
  openUsercentricsSecondLayer,
} from '@xing-com/cookie-consent-usercentrics';
import type { UsercentricsObject } from '@xing-com/cookie-consent-usercentrics';

const USERCENTRICS_ACTION_TIMEOUT_MS = 6000;

const getUsercentricsObject = (): UsercentricsObject | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  return window.__ucCmp as UsercentricsObject | undefined;
};

// Usercentrics calls can hang when the CMP script is blocked, so fail visibly.
const withUsercentricsTimeout = <T>(
  promise: Promise<T>,
  timeoutMs = USERCENTRICS_ACTION_TIMEOUT_MS
): Promise<T> => {
  return new Promise<T>((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      reject(new Error('Usercentrics action timed out'));
    }, timeoutMs);

    promise.then(
      (value) => {
        clearTimeout(timeoutId);
        resolve(value);
      },
      (error: unknown) => {
        clearTimeout(timeoutId);
        reject(error);
      }
    );
  });
};

export const openUsercentricsPartners = (
  settingsId?: string
): Promise<void> => {
  return withUsercentricsTimeout(openUsercentricsSecondLayer(settingsId));
};

export const acceptAllUsercentricsConsents = (
  settingsId?: string
): Promise<void> => {
  return withUsercentricsTimeout(
    ensureUsercentricsV3Loaded({
      settingsId,
      suppressCmpDisplay: true,
    }).then(() => {
      const usercentricsObject = getUsercentricsObject();

      if (!usercentricsObject?.acceptAllConsents) {
        throw new Error('Usercentrics accept all is unavailable');
      }

      usercentricsObject.acceptAllConsents().catch((error: unknown) => {
        console.error('Usercentrics accept all failed:', error);
      });
    })
  );
};
